var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 11.5,
    viewBox: "0 0 11.5 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.714,11.714,10.99,9.4a1.216,1.216,0,0,0-.826-.359,4.313,4.313,0,1,0-.483.483,1.216,1.216,0,0,0,.359.826l2.317,2.724a.966.966,0,1,0,1.357-1.357Zm-6.831-2.6A2.875,2.875,0,1,1,9.758,6.241,2.875,2.875,0,0,1,6.883,9.116Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#8b8b8b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.81b9642b5189ba4a66bd846bf9549a0c.svg";
export { ForwardRef as ReactComponent };